<template>
    <form @submit.prevent="submit" class="pt-5">

        <field-mobile v-model="form.mobile" required placeholder="نام کاربری" label="نام کاربری" hide-label/>
        <field-password v-model="form.password" required placeholder="پسورد" label="پسورد" hide-label/>

        <button-submit title="ورود"/>

        <alert :success="success" :danger="danger"></alert>

    </form>
</template>

<script>
    import FieldText from "../fields/FieldText";
    import ButtonSubmit from "../ButtonSubmit";
    import FieldPassword from "../fields/FieldPassword";
    import Alert from "../Alert";
    import FieldMobile from "../fields/FieldMobile";

    export default {
        name: "FormLogin",
        components: {FieldMobile, Alert, FieldPassword, ButtonSubmit, FieldText,},
        data() {
            return {
                form: {
                    mobile: null,
                    password: null,
                },
                danger: null,
                success: null
            }
        },
        methods: {
            submit(e) {
                this.$validator.validateAll()
                    .then((isValid) => {
                        if (isValid) {
                            this.submitLogin()
                        }
                    });
            },
            submitLogin() {
                this.$auth.login({
                    data: this.form,
                }).catch((error) => {

                    this.danger = error.response.data.message;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/forms/FormLogin.vue